import { optionSubcategory_pbp } from './pbpSubCategory.locstring.json';
import { OptionSubCategory } from 'owa-options-core';
import SignaturePbpOption from 'owa-pbp-option/lib/SignaturePbpOption';
import SharePbpOption from 'owa-pbp-option/lib/SharePbpOption';
import PublishPbpOption from 'owa-pbp-option/lib/PublishPbpOption';
import ServiceListPbpOption from 'owa-pbp-option/lib/ServiceListPbpOption';
import ComposeServicePbpOption from 'owa-pbp-option/lib/ComposeServicePbpOption';
import initPbpSettings from 'owa-pbp-option-publishing-settings/lib/orchestration/initPbpSettings';

let pbpSubCategory: OptionSubCategory = {
    key: 'pbp',
    titleStringKey: optionSubcategory_pbp,

    options: [
        PublishPbpOption,
        SharePbpOption,
        ServiceListPbpOption,
        ComposeServicePbpOption,
        SignaturePbpOption,
    ],
    onSelected: initPbpSettings,
};

export default pbpSubCategory;
